angular.module("iconoglobe").directive("backgroundImageSource", [function () {
    console.log("Directive->backgroundImage loaded")
    return {
        restrict: "A",
        scope:{
            onloadBackground:"&"
        },
        link: function (scope, element, attributes) {
            var image = new Image();
            image.onload = function () {
                // the image must have been cached by the browser, so it should load quickly
                scope.$apply(function () {
                    element.css({ backgroundImage: 'url("' + attributes.backgroundImageSource + '")' });
                });
                // Call the on load function
               scope.onloadBackground()
            };
            image.src = attributes.backgroundImageSource;
        }
    };
}]);